// extracted by mini-css-extract-plugin
export default {"container":"Cookies_container__aFMRD","toast":"Cookies_toast__9g+Qc"};